export const permissionConstants = {
    PERMISSION_SET: "PERMISSION_SET",
    PERMISSION_CLEAR: "PERMISSION_CLEAR"
  };
  